//@flow
import StockStore from './stockStoreClass';

export default new StockStore();
